import { render, staticRenderFns } from "./FirstStepAssistance.vue?vue&type=template&id=0ca7480a&"
import script from "./FirstStepAssistance.vue?vue&type=script&lang=js&"
export * from "./FirstStepAssistance.vue?vue&type=script&lang=js&"
import style0 from "./FirstStepAssistance.vue?vue&type=style&index=0&id=0ca7480a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports